import { Component, input, InputSignal } from '@angular/core';

import { TranslateDirective } from '@ngx-translate/core';

import { ButtonComponent } from '../button/button.component';
import { ModalCloseDirective } from '../modal/components/modal-close/modal-close-button.directive';

/**
 * The Confirm Cancel Button Component
 *
 * This component is the Cancel Button for the confirm message. closes confirm modal with 'cancel' reason
 */
@Component({
  imports: [
    TranslateDirective,
    ButtonComponent,
    ModalCloseDirective
  ],
  selector: 'td-wb-confirm-button-cancel',
  templateUrl: 'confirm-button-cancel.component.html',
  styleUrls: ['confirm-button-cancel.component.scss']
})
export class ConfirmButtonCancelComponent {
  readonly value: InputSignal<string> = input<string>('CANCEL');
}
